export * from './ubiMenu.service';



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/services/ubiMenu/index.ts